export default __webpack_public_path__ + "static/media/participant.4106933e.png";